import styled from "styled-components";

export const Container = styled.div`
  footer {
    width: 100%;
    padding: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #000;
    color: #fff;
    box-sizing: border-box;
    font-family: "Poppins", sans-serif;
  }
`;
